
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94f6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94f6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $13f959e96aa2e379$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["aT88m","index.0cbe5663.js","6Bz94","about.eaf6eac9.png","4y3a6","work.fbfb9c2a.png","bnwVI","dev.da0fda8f.png","fdVi4","bubble-pop.e081c084.gif","iQNf7","softcomputers_appleiie.4d1cf316.jpg","hLngC","daisybell1.a292c481.jpg","iw9TE","paintbucket-icon.b20c801a.jpg","lhDyI","miracle-screenshot.ae10c03e.png","h251K","animegirl-screenshot.379b2495.jpg","9cUDT","mainframe.5022c6fe.gif","ixVsI","visuals1.2f6dbc40.jpg","eIBpr","voices.a2e50ec1.jpg","9NiBI","softcomputers_booklet1.64026890.jpg","ftApr","softcomputers_booklet2.5b025938.jpg","idXBW","daisybellbfa.5f198311.jpg","lRLDJ","paintbucket.43d76d3b.jpg","2Vrkl","visuals2.1f3ef697.jpg","5xgfq","apollo_1.744c75ae.jpg","2Ig8z","r1_poster.07f3bdb3.jpg"]'));


//# sourceMappingURL=index.runtime.03e50501.js.map
